import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ViewLeadContext } from "../..";
import { commonType } from "../../..";
import DataNotFound from "../../../../../../components/Data Not Found";
import Form from "../../../../../../components/View Lead Components/MenuData/Quotation Components/Form";
import useLoading from "../../../../../../hooks/useLoading";
import { getQuotation } from "../../../../../../lib/api functions/lead/quotation";
import { MainContext } from "../../../../../../utils/private_routes/PrivateRoutes";
import { ParamType } from "./type";

const ViewQuotation = () => {
  const { setting } = useContext(MainContext);
  const { id } = useContext(ViewLeadContext);
  const [commonData, setCommonData] = useState<commonType>({
    data: undefined,
    modal: false,
    check: "",
  });

  const [loading, showLoader, hideLoader] = useLoading();
  const [quotations, setQuotations] = useState<any>([]);
  const [totalResult, setTotalResult] = useState<number>(0);

  const [params, setParams] = useState<ParamType>({
    // page: 1,
    // per_page: 10,
    lead: id,
  });

  const fn = {
    openForm: (data: any) => {
      setCommonData({
        data: data ? data : undefined,
        modal: true,
        check: "quotation_menu",
      });
      document.body.style.overflow = "hidden";
    },
    getQuotations: async (params?: ParamType) => {
      showLoader();
      const res = await getQuotation(params);
      if (res) {
        setQuotations(res.data.quotations);
        setTotalResult(res.data.total);
        hideLoader();
      }
    },
  };

  useEffect(() => {
    fn.getQuotations(params);
  }, []);

  return (
    <>
      <div>
        <div className="viewlead_content_header d-flex justify-content-between">
          <p className="m-0 font14x500 textColor3">Attach Mail of Quotation</p>
          <button
            className="btn font12x500 buttonOne shadow-none"
            onClick={() => fn.openForm(null)}
          >
            <img src="/Assets/Svg/plusIcon.svg" alt="icon" className="me-2" />
            Attach New
          </button>
        </div>

        {loading ? (
          <Skeleton height="190px" borderRadius="8px" />
        ) : (
          <div className="menu_content_wrapper">
            {/* table */}
            {quotations?.length !== 0 ? (
              <div className="entry_table_wrapper">
                <div className="table_wrapper">
                  <table className="table">
                    <thead className="table_head_small">
                      <tr className="font12x500 textColor3">
                        <th scope="col">Date</th>
                        <th scope="col">Quotation No.</th>
                        <th scope="col">Title</th>
                        <th scope="col">Attachments</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quotations?.map((quotation: any, i: number) => {
                        return (
                          <tr key={i} className="font12x400">
                            <td>
                              {moment(quotation?.createdAt).format(
                                setting?.dateFormat
                              )}
                            </td>
                            <td>{quotation?.number}</td>
                            <td
                              title={quotation?.description}
                              style={{ maxWidth: 100 }}
                            >
                              <span>{quotation?.title}</span>
                              <br />
                              <span className="textColor2 mb-1 font10x400">
                                {quotation?.description}
                              </span>
                            </td>
                            <td>
                              {quotation?.attachments?.length
                                ? quotation?.attachments?.map(
                                    (item: any, i: number) => {
                                      return (
                                        <a
                                          className="text-decoration-none"
                                          href={`${process.env.REACT_APP_IMAGE_URL}${item?.url}`}
                                          target="_blank"
                                        >
                                          <p
                                            key={i}
                                            className="mb-1 textColor2 font10x600 cursor_pointer"
                                          >
                                            {item?.filename}
                                          </p>
                                        </a>
                                      );
                                    }
                                  )
                                : "--"}
                            </td>
                            <td>
                              <p
                                className="mb-0 font10x400 textColor2 cursor_pointer"
                                onClick={() => fn.openForm(quotation)}
                              >
                                Edit
                              </p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <DataNotFound />
            )}
          </div>
        )}
      </div>

      {/* form modal */}
      {commonData?.modal && commonData?.check === "quotation_menu" && (
        <Form
          state={commonData}
          setState={setCommonData}
          apiCall={fn.getQuotations}
          params={params}
        />
      )}
    </>
  );
};

export default ViewQuotation;
